import React, { useContext, useEffect, useRef } from 'react'
import { FreyrComponentLibraryProvider, ProcessBar } from '@freyr/freyr-react-common-components';
import { useAppCookies } from '../../assets/utils';
import styles from './index.module.scss';
import { XevmpdContext } from '../../App';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import { styled } from "@mui/material/styles";
import { Button, Tooltip } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Collapse from '@mui/material/Collapse';
import ProcessButton, { ProcessButtonRefFormat } from './ProcessButton';
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

interface ProcessBarComponentProps {
    xevmpdId?: string;
    taskButtonConfig?: any;
}
export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`&& .${tooltipClasses.tooltip}`]: {
    overflow: "auto",
    maxHeight: "36vh",
    wordBreak: "break-all",
    color:'#FFF !important',
    fontSize:'12px'
  },
}));

export const LinkLikeButton = styled(Button)(() => ({
  marginLeft: "var(--ff-space-condensed)",
  color: "var(--ff-primary-600) !important",
  cursor: "pointer",
  border: "none",
  backgroundColor: "transparent",
  verticalAlign:'baseline',
  "&.MuiButton-root":{
    padding:'0px',
    fontSize: "var(--ff-font-size-body-verysmall)",
  },
  "&&:hover": {
    backgroundColor: "transparent",
  },

  "&.Mui-disabled": {
    textDecoration: "none",
  },
}));

function ProcessBarComponent({ xevmpdId, taskButtonConfig }: ProcessBarComponentProps) {
      const { token, tenantID, userName } = useAppCookies();
      const { setTaskButtonConfig } = useContext(XevmpdContext);
      const { t } = useTranslation();
      const [showMore, setShowMore] = React.useState(false);
    const  { processRelatedInfo,setProcessRelatedInfo } = useContext(XevmpdContext);
      const taskAction = React.useRef<string>("");
        const processButtonRef = useRef<ProcessButtonRefFormat>(null);
      

  // Store taskButtonConfig in context when it's provided
  useEffect(() => {
    if (taskButtonConfig !== undefined) {
      setTaskButtonConfig(taskButtonConfig);
    }
  }, [taskButtonConfig, setTaskButtonConfig]);
  
  const processAssociationId = taskButtonConfig?.processAssociationId;
  const processJudge = taskButtonConfig?.processJudge;
  const buttonOptions = [...(taskButtonConfig?.taskResults ?? [])];

  return (
    <div style={{marginTop:"20px", marginRight:"12px"}}>  
        
      {/* Process bar container at the very top */}


     <div className={styles["process-button-bar-container"]}>
        {!!processAssociationId && processJudge !== "NOT_STARTED" && (
          <>
            {/* <div
              className={classnames(styles["process-bar-container"], {
                [styles["only-display-process-bar"]]:
                  buttonOptions.length === 0,
              })}
            >
              <ProcessBar processAssociationId={processAssociationId} />
            </div> */}
            {buttonOptions.length > 0 ? (
              <div className={styles["process-button-part"]}>
                <div className={styles["process-button-part-text"]}>
                  <div>
                    <span className={styles["bolder-text"]}>
                      {t("workflow.task")}:{" "}
                      {processRelatedInfo?.currentTaskName ?? "-"}{" "}
                    </span>
                    {/* <span className={styles["date-text"]}>
                      <CalendarTodayIcon
                        sx={{ fontSize: "12px", verticalAlign: "-1px" }}
                      />{" "}
                      TODO need backend api
                      26 Dec 2024
                    </span> */}
                    <LinkLikeButton
                      variant="text"
                      size="small"
                      onClick={() => {
                        setShowMore((prev) => !prev);
                      }}
                    >
                      {showMore ? "Show Less" : "Show More"}
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "16px",
                          verticalAlign: "-4px",
                          marginLeft: "4px",
                          transition: "transform 0.3s ease",
                          transform: showMore
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    </LinkLikeButton>
                  </div>
                  <Collapse in={showMore}>
                    <div className={styles["instructions-part"]}>
                      <span className={styles["bolder-text"]}>
                        {t("workflow.instructions")}:{" "}
                      </span>
                      {processRelatedInfo?.instructions ? (
                        <CustomTooltip
                          placement="bottom-start"
                          title={processRelatedInfo?.instructions}
                        >
                          <span>{processRelatedInfo?.instructions}</span>
                        </CustomTooltip>
                      ) : (
                        <span> - </span>
                      )}
                    </div>
                  </Collapse>
                </div>
                <div className={styles["process-button-part-button"]}>
                 <ProcessButton  ref={processButtonRef}
                                  taskButtonConfig={taskButtonConfig} xevmpdId={xevmpdId}></ProcessButton>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div></div>
  )
}

export default ProcessBarComponent